
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { useEffect, useState } from 'react'
import { IconButton } from '@mui/material';
import Spinner from '../common/spinner';

const TableFooter = ({
    list,
    visbleList,
    setShownItems,
    numOfItems,
    onNext: next,
    shownItems,
    hasNext, totalPages: totalCount,
    isloading
}) => {
    const [isNext, setIsnext] = useState(false);
    const [isPrev, setIsPrev] = useState(false);
    useEffect(() => {
        handlechange()
    }, []);
    useEffect(()=>{
        // console.log("startChanged to",shownItems.start)
        if(shownItems.start===0){ 
            setIsPrev(false)
        }else if(shownItems.start>0){
            setIsPrev(true)
        }
    },[shownItems])
    useEffect(()=>{
        if(!hasNext&&shownItems.end>=list.length) setIsnext(false)
    },[hasNext])
    const handlechange = () => {
        const length = visbleList.length||0;
        const pages = Math.ceil(length / numOfItems);
        if (length <= numOfItems) {
            // setShownumbers([1]);
            // setIsnext(false);
            setIsPrev(false);
            if (length >= numOfItems) setIsnext(true);
        } else {
            setIsnext(true)
        }
    }

    const onNext = async () => {
        const newStart=shownItems.end
        const newEnd=shownItems.end+numOfItems
        //get total compare with end one of showns
        //slice first and add to end another one
        if(isloading) return 
        if (!hasNext&&shownItems.end>=list.length) {
           return setIsnext(false);
        }
        // console.log(shownItems.end <= list.length, hasNext, list.length < shownItems.end + numOfItems);
        if (shownItems.end <= list.length){
            
            // if(shownItems.end>=list.length&&!hasNext){
            //     setIsnext(false)
            // }else{ 
                setIsnext(true)
            // }
            
        } 
        if (shownItems.start > 0) setIsPrev(true)
        // setIsPrev(true);
        if (hasNext && 
            (list.length < shownItems.end + numOfItems || visbleList.length < shownItems.end + numOfItems)) 
            {
            // console.log("hereon next")
            await next(shownItems.end, numOfItems, hasNext, setShownItems)
        } else if (list.length>=shownItems.end) {
            // console.log("here on no next")
            const tempEnd = (shownItems.end + numOfItems) > list.length ? list.length : shownItems.end + numOfItems
            // console.log(tempEnd,shownItems.end+numOfItems,"tempend")
            setShownItems(s => ({
                ...s,
                start: s.end,
                end: tempEnd
            }))
            setIsPrev(true)
            if (!hasNext && (shownItems.end + numOfItems) >= list.length) setIsnext(false)
        }

    };
    const onPrev = () => {
        //get total compare with end one of showns
        //slice first and add to end another one
        if (!isPrev) return
        if (shownItems.start-numOfItems  === 0) {
            setIsPrev(false);
        }

        if (list[shownItems.start]) {
            setIsnext(true);
        }
        setShownItems((s) => {
            return {
                ...s,
                start: s.start - numOfItems,
                end: s.start,
            };
        });
        // if no items last so diable it

    };
    return (
        
        <div
            style={{
                display: "flex",
                // position:"absolute",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: 20,
                bottom: 10,
                right: 20,
                paddingBottom: 10
            }}
        >
            {/* <div style={{
                fontSize: 18,
                marginRight: 5,
            }}>
                {`${((shownItems.end>)/totalCount)*(numOfItems>totalCount?totalCount:numOfItems)} of ${Math.ceil(totalCount/numOfItems)}`}
            </div> */}
            <div
                style={{ opacity: !isPrev && 0.5, marginRight: 10, cursor: isPrev ? "pointer" : "default" }}
                onClick={onPrev}
                className="table-footer-icon"
            >
                <IconButton sx={{ color: "white" }} >
                    <ArrowBackIosNewIcon color='gray' />
                </IconButton>
            </div>
            {/* {shownNumbers.map((i) => (
                <div
                    key={i + "number"}
                    onClick={() => onSelect(i)}
                    style={{ backgroundColor: currNum == i && "#3980FD" }}
                    className="footer-icon"
                >
                    <p style={{ color: currNum == +i && "white" }}>{i}</p>
                </div>
            ))} */}

            <div
                style={{ opacity: !isNext && 0.5, cursor: isNext ? "pointer" : "default" }}
                onClick={onNext}
                className="table-footer-icon"
            >
                <IconButton sx={{ color: "white" }} >
                    {isloading?<Spinner color={"green"} />:<ArrowForwardIosIcon color='gray' />}
                </IconButton>
            </div>
            {/* <div>
                <p>Ask More</p>
            </div> */}
        </div>
    )
}

export default TableFooter